export const USER_CANCELLED_CODE = 'USER_CANCELLED';
const CANCELLED_PATTERNS = [
    'access_denied',
    'access denied',
    'user_cancelled_authorize',
    'user_cancelled',
    'user cancelled',
    'user canceled',
    'login cancelled',
    'login canceled',
    'popup closed',
    'window was closed',
];
export function createUserCancelledError(message) {
    const error = new Error(message);
    error.code = USER_CANCELLED_CODE;
    return error;
}
/**
 * Detects cancellation-like messages and marks them with USER_CANCELLED.
 * Falls back to a regular Error when the message doesn't look like a user cancellation.
 */
export function inferUserCancelledError(message) {
    const normalized = message.toLowerCase();
    if (CANCELLED_PATTERNS.some((pattern) => normalized.includes(pattern))) {
        return createUserCancelledError(message);
    }
    return new Error(message);
}
//# sourceMappingURL=errors.js.map